import HistoricList from "@/components/Shared/HistoricList.vue"
import Rules from "@/utils/Rules";
import Utils from '@/scripts/Utils';
import cloneDeep from 'lodash/cloneDeep';
import SolutionsServices from '@/services/firebase/SolutionsServices/SolutionsServices';
import SolutionsGroup from '@/services/firebase/SolutionsGroup/SolutionsGroup';
import DiagnosticProposalService from '@/services/firebase/DiagnosticProposal/DiagnosticProposalService';
import InputMoney from "@/components/Forms/Input/input-money.vue";
import NumberInput from "@/components/Inputs/NumberInput.vue";
import RichTextEditor from '@/components/formatter/RichTextEditor.vue';
import { showErrorSnackBar, showSuccessSnackBar } from "@/utils/SnackBartHelper"
import { mapGetters } from "vuex";

export default {
    name: "Proposal",

    components: {
        HistoricList,
        InputMoney,
        NumberInput,
        RichTextEditor
    },

    props: {
        desiredProposal: {
            type: Array,
            default: []
        },
        show: {
            type: Boolean,
            default: false,
        },
        param: {
            type: Object,
            default: () => ({})
        },
        idLead: {
            type: String,
            default: null
        },
        idFranchisee: {
            type: String,
            default: null
        },
        proposalId: {
            type: String,
            default: null
        },
        fixedProposalType: {
            type: String,
            default: null
        },
        readonly: {
            type: Boolean,
            default: false
        },
    },

    data: () => ({
        proposalList: [],
        diagnostic: {},
        projectSolutions: [],
        is_loading: false,
        modal: false,
        serviceModal: false,
        productModal: false,
        columnVisibility: {
            solution: true,
            group: true,
            quantity: true,
            unitPrice: false,
            total: false,
            totalInvestment: true
        },

        solutionList: [],

        solutions: [],
        items: [],
        typeProposal: {
            defaultPrice: 600.99,

            number_water_start:null,
            number_water_target:null,
            number_water_360:0,
            number_reservation:0,

            reservation_plan: 199.90,
            managementPlan: null,
            paybackMin: 50,
            paybackMax: 30,

            water_start_plan: 199.90,
            water_target_plan: 374.90,
            water_360_plan: 99.90,
            water_start_plan_month_additional_spot: 139.90,
            water_target_plan_month_additional_spot: 259.90,
            water_360_plan_month_additional_spot: 449.90,

            water_start_plan_yearly: 149.90,
            water_target_plan_yearly: 299.90,
            water_360_plan_yearly: 499.90,
            water_start_plan_yearly_additional_spot: 99.90,
            water_target_plan_yearly_additional_spot: 149.90,
            water_360_plan_yearly_additional_spot: 249.90,
            isFranchise: false,
            obs: '',
        },
        item: {
            unitPrice: 0,
            amount: 0,
            total: 0,
        },
        listSolutions: [],
        listServices: [],
        listProducts: [],
        allSolutions: [],
        groupsData: [],
        isValidForm: false,
        usedProposalTypes: [],
        options: [
            { text: "Modelo Performance", value: "model_performance", disabled: false },
            { text: "Venda do Projeto", value: "investment", disabled: false },
            { text: "Pré-Fixado", value: "pre_fixed", disabled: false },
            { text: "Gestão", value: "management", disabled: false },
            { text: "Venda de Kit", value: "kit_sell", disabled: false }
          ],
          headersInsatallations:[
            { text: "Solução", value: "solution" },
            { text: "Observação", value: "description" },
          ],
        headersSolutions: [
            { text: "Solução", value: "solution" },
            { text: "R$ Unidade", value: "unitPrice" },
            { text: "Qntd.", value: "amount" },
            { text: "Total", value: "total" },
        ],
        headersService: [
            { text: "Serviços", value: "serviceName" },
            { text: "R$ Unidade", value: "unitPrice" },
            { text: "Qntd.", value: "amount" },
            { text: "Total", value: "total" },
        ],
        headersProduct: [
            { text: "Produtos", value: "productName" },
            { text: "R$ Unidade", value: "unitPrice" },
            { text: "Qntd.", value: "amount" },
            { text: "Total", value: "total" },
        ],
        editProposalId: null,
        indexEdit: -1, 
        requiredRule: v => (v !== null ? true : 'Por favor, selecione uma opção.'),
        rulesRange: v => (v && v >= 0 && v <= 100) || 'O valor deve estar entre 0 e 100.',
        daysToAdd: 30,
        displayHydrometerMode: 'installation',
        displayReservoirMode: 'installation',
    }),

    computed: {
        ...mapGetters([
            "getCurrentUser",
            "getCurrentUserData",
        ]),
        isReadonly() {
            return this.readonly || false;
        },
        rulesRequired() {
            return Rules.required()
        },
        currentUserFranchiseeId() {
            return this.idFranchisee || this.getCurrentUserData?.id || null;
        },
        serviceList() {
            let data = this.allSolutions.filter(({ type }) => type === "Serviço")
            data.sort(this.orderSolution)
            return data
        },
        productList() {
            let data = this.allSolutions.filter(({ type }) => type === "Produto")
            data.sort(this.orderSolution)
            return data
        },
        // Buscar serviços de instalação e consultoria configurados para adição automática
        installationService() {
            return this.allSolutions.find(({ type, autoAddForKitSell, kitSellServiceType }) => 
                type === "Serviço" && 
                autoAddForKitSell === true &&
                kitSellServiceType === "installation"
            );
        },
        consultingService() {
            return this.allSolutions.find(({ type, autoAddForKitSell, kitSellServiceType }) => 
                type === "Serviço" && 
                autoAddForKitSell === true &&
                kitSellServiceType === "consulting"
            );
        },
        sumValueTotal() {
            const lists = [
                ...this.listSolutions.filter(item => item.selected),
                ...this.listServices.filter(item => item.selected),
                ...this.listProducts.filter(item => item.selected)
            ];
            return lists.reduce((subTotal, item) => subTotal + Number(item.total), 0).toFixed(2);
        },
        discountTotal() {
            const { discountType, discountValue } = this.typeProposal;
            const totalValue = parseFloat(this.sumValueTotal) || 0;
            const discount = parseFloat(discountValue) || 0;
        
            if (discountType === "monetary") {
                return (totalValue - discount).toFixed(2);
            } else if (discountType === "percentage") {
                return (totalValue - (discount / 100) * totalValue).toFixed(2);
            }
        
            return totalValue.toFixed(2);
        },
        getAccountReference() {
            if (this.diagnostic && this.diagnostic.historics && this.diagnostic.historics.length) {
                const historics = this.diagnostic.historics
                const totalConsumption = historics.reduce((sum, item) => sum + Number(item.accountAmount), 0);
                return (totalConsumption / historics.length)
            }
            return 0
        },
        getPayback() {
            const reference = this.getAccountReference * 12;
            const selectedProducts = this.listProducts.filter(item => item.selected);
            const selectedServices = this.listServices.filter(item => item.selected);
            const selectedSolutions = this.listSolutions.filter(item => item.selected);
            
            const totalInvestment = this.resolveTotalInvestment(selectedProducts, selectedServices, selectedSolutions);
            const economyMax = Number(this.typeProposal.paybackMax) / 100;
            const economyMin = Number(this.typeProposal.paybackMin) / 100;

            const calculatePayback = (economy) => {
                return totalInvestment / ((reference * economy) / 12)
            }

            const paybackMax = calculatePayback(economyMax);
            const paybackMin = calculatePayback(economyMin);
            if(paybackMax === Infinity || paybackMax === 0 || this.typeProposal.type === 'model_performance') return `Retorno Imediato`;
            else if (isNaN(paybackMax) || isNaN(paybackMin)) return `Dados Insuficientes`;
            else return `Entre ${paybackMin.toFixed(0)} e ${paybackMax.toFixed(0)} meses`;
        },
        hydrometerSolutionsFormatted() {
            if (!this.param || !this.param.hydrometerList) return [];
            const filteredList = this.param.hydrometerList.filter(item => {
                if (this.displayHydrometerMode === 'installation') {
                    return item.ifInstallation;
                } else if (this.displayHydrometerMode === 'loan') {
                    return item.ifLoan;
                }
                return false; // Default case, should not happen with current modes
            });

            return filteredList.map(item => ({
                solution: item.model || 'Hidrômetro', 
                description: item.comments || "", 
            }));
        },
        reservoirSolutionsFormatted() {
            if (!this.param || !this.param.reservoirList) return [];

            const filteredList = this.param.reservoirList.filter(item => {
                if (this.displayReservoirMode === 'installation') {
                    return item.ifInstallation;
                } else if (this.displayReservoirMode === 'loan') {
                    return item.ifLoan;
                }
                return false; // Default case, should not happen with current modes
            });

            return filteredList.map(item => ({
                solution: item.type || 'Sensor', 
                description: item.comments || "", 
            }));
        },
    },

    methods: {
        applyProposalTypeAvailability(usedTypesParam) {
            // Sempre permitir todos os tipos no select (sem filtrar por tipos já existentes
            // e sem restringir por prospecção). O bloqueio/readonly em edição é feito na UI.
            this.options = this.options.map((option) => ({
                ...option,
                disabled: false,
            }));
        },
        resolveTotalInvestment(listProducts, listServices, listSolutions) {
            const calculateTotal = (list) => {
                return list.reduce((acc, item) => acc + (item.total || 0), 0);
            };

            const totalProducts = calculateTotal(listProducts || []);
            const totalServices = calculateTotal(listServices || []);
            const totalSolutions = calculateTotal(listSolutions || []);

            const grandTotal = totalProducts + totalServices + totalSolutions;

            if (this.typeProposal.hasDiscount) {
                let discountValue = this.typeProposal.discountValue || 0;

                if (this.typeProposal.discountType === 'percentage') {
                    const discountAmount = (grandTotal * discountValue) / 100;
                    return this.formatCurrencyValue(grandTotal - discountAmount);
                } else if (this.typeProposal.discountType === 'monetary') {
                    return this.formatCurrencyValue(grandTotal - discountValue);
                }
            }

            return parseFloat(grandTotal).toFixed(2);
        },
        formatCurrencyValue(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(value);
        },
        selectedProposal(proposal) {
            if (proposal) {
                // Se não tiver editProposalId definido, usar o id_doc da proposta carregada
                if (!this.editProposalId) {
                    this.editProposalId = proposal.id_doc || this.proposalId;
                }
              
                this.typeProposal = {
                    ...proposal.typeProposal,
                    isFranchise: proposal.typeProposal && typeof proposal.typeProposal.isFranchise !== 'undefined' ? proposal.typeProposal.isFranchise : false,
                    obs: proposal.typeProposal?.obs || '',
                }

                this.listSolutions = this.listSolutions.map(item => {
                    const found = proposal.listSolutions.find(p => p.solutionId === item.solutionId);
                    return {
                        ...item,
                        selected: found
                            ? (found.selected !== undefined ? found.selected : true)
                            : (item.selected !== undefined ? item.selected : true)
                    };
                });

                this.listServices = (proposal.listServices || []).map(item => ({
                    ...item,
                    selected: item.selected !== undefined ? item.selected : true
                }));

                this.listProducts = (proposal.listProducts || []).map(item => ({
                    ...item,
                    selected: item.selected !== undefined ? item.selected : true
                }));

                this.columnVisibility = {
                    solution: proposal.columnVisibility?.solution ?? true,
                    group: proposal.columnVisibility?.group ?? true,
                    quantity: proposal.columnVisibility?.quantity ?? true,
                    unitPrice: false,
                    total: false,
                    totalInvestment: proposal.columnVisibility?.totalInvestment !== undefined ? proposal.columnVisibility.totalInvestment : true
                }
            } else {
                this.editProposalId = null
                this.typeProposal = {}
                this.listServices = []
                this.listProducts = []
                this.columnVisibility = {
                    solution: true,
                    group: true,
                    quantity: true,
                    unitPrice: false,
                    total: false,
                    totalInvestment: true
                }
            }
        },
        selectUnitPrice(solution) {
            const selectedSolution = this.allSolutions.find(({ id }) => id === solution)
            this.item.unitPrice = selectedSolution.price
        },
        orderSolution(itemA, itemB) {
            let solutionNameA = ((itemA.group ? itemA.group : '') + (itemA.solutionCod ? itemA.solutionCod : ''))
            let solutionNameB = ((itemB.group ? itemB.group : '') + (itemB.solutionCod ? itemB.solutionCod : ''))
            if (solutionNameA > solutionNameB) {
                return 1
            } else if (solutionNameA < solutionNameB) {
                return -1
            } else {
                return 0
            }
        },
        clearItem() {
            this.item = {
                unitPrice: 0,
                amount: 0,
                total: 0,
            }
            this.indexEdit = -1
            this.modal = false
            this.serviceModal = false
            this.productModal = false
        },
        async addNewItemSolution() {
            this.mode = 'create'
            this.serviceModal = true
        },
        async addNewItemProduct() {
            this.mode = 'create'
            this.productModal = true
        },
        async saveItem() {
            Object.keys(this.listSolutions[this.indexEdit]).forEach(
                (key) => {
                    this.$set(this.listSolutions[this.indexEdit], key, this.item[key])
                }
            )
            this.clearItem()
        },
        async saveItemService() {
            delete this.item.product 
            const selectedSolution = this.allSolutions.find(({ id }) => id === this.item.service)
            if (this.mode === "create") {
                this.listServices.push({
                    ...this.item,
                    serviceName: selectedSolution.solution,
                    selected: true,
                })
            } else {
                this.item = {
                    ...this.item,
                    total: (this.item.unitPrice * this.item.amount),
                    serviceName: selectedSolution.solution
                }
                Object.keys(this.listServices[this.indexEdit]).forEach(
                    (key) => {
                        this.$set(this.listServices[this.indexEdit], key, this.item[key])
                    }
                )
            }
            this.clearItem()
        },
        async saveItemProduct() {
            const selectedSolution = this.allSolutions.find(({ id }) => id === this.item.product)
            if (this.mode === "create") {
                this.listProducts.push({
                    ...this.item,
                    productName: selectedSolution.solution,
                    selected: true,
                })
            } else {
                this.item = {
                    ...this.item,
                    total: (this.item.unitPrice * this.item.amount),
                    productName: selectedSolution.solution
                }

                Object.keys(this.listProducts[this.indexEdit]).forEach(
                    (key) => {
                        this.$set(this.listProducts[this.indexEdit], key, this.item[key])
                    }
                )
            }
            this.clearItem()
        },
        async editItem(item) {
            this.mode = 'edit'
            this.indexEdit = this.listSolutions.findIndex(prod => prod === item)
            this.item = cloneDeep(this.listSolutions[this.indexEdit])
            this.modal = true
        },
        async editItemService(item) {
            this.mode = 'edit'
            this.indexEdit = this.listServices.findIndex(prod => prod === item)
            this.item = cloneDeep(this.listServices[this.indexEdit])
            this.serviceModal = true
        },
        async editItemProduct(item) {
            this.mode = 'edit'
            this.indexEdit = this.listProducts.findIndex(prod => prod === item)
            this.item = cloneDeep(this.listProducts[this.indexEdit])
            this.productModal = true
        },
        async deleteItemProduct(item) {
            this.listProducts = this.listProducts.filter((prod) => prod !== item)
            this.clearItem()
        },
        async deleteItemService(item) {
            this.listServices = this.listServices.filter((prod) => prod !== item)
            this.clearItem()
        },
        async getSolutions() {
            
            if (!this.projectSolutions ) return
            this.projectSolutions = this.projectSolutions.filter(item => item.isDeleted !== true)
            const listSearchSolution = this.projectSolutions.map(({ solution }) => solution)

            const countSolutions = (arr) => {
                return arr.reduce((acc, obj) => {
                    const solution = obj.solution;
                    const amount = Number(obj.amountSolution) || 0; 
                    acc[solution] = (acc[solution] || 0) + amount;
                    return acc;
                }, {});
            };
            const sumSolutions = countSolutions(this.projectSolutions)
            let response = await SolutionsServices.GetSolutionsByIds(listSearchSolution)
            this.listSolutions = Object.values(response).map((solution) => ({
                amount: sumSolutions[solution.id],
                solution: solution.solution,
                solutionId: solution.id,
                total: Number((sumSolutions[solution.id] * Number(solution.price)).toFixed(2)),
                unitPrice: Number(Number(solution.price).toFixed(2)),
                selected: true,
            }))
            
            // Adicionar serviços automáticos para proposta de venda de kit
            if (this.typeProposal.type === 'kit_sell') {
                await this.addKitSellServices();
            }
        },
        
        async addKitSellServices() {
            // Verificar se os serviços já foram adicionados
            const hasInstallation = this.listServices.some(service => 
                service.serviceName && (
                    service.serviceName.toLowerCase().includes("instalação") || 
                    service.serviceName.toLowerCase().includes("instalacao")
                )
            );
            const hasConsulting = this.listServices.some(service => 
                service.serviceName && (
                    service.serviceName.toLowerCase().includes("consultoria") || 
                    service.serviceName.toLowerCase().includes("consultor")
                )
            );
            
            // Adicionar serviço de instalação se não existir
            if (!hasInstallation && this.installationService) {
                this.listServices.push({
                    service: this.installationService.id,
                    serviceName: this.installationService.solution,
                    unitPrice: 0,
                    amount: 1,
                    total: 0,
                    selected: true,
                    isAutoAdded: true, // Flag para identificar serviços adicionados automaticamente
                });
            }
            
            // Adicionar serviço de consultoria se não existir
            if (!hasConsulting && this.consultingService) {
                this.listServices.push({
                    service: this.consultingService.id,
                    serviceName: this.consultingService.solution,
                    unitPrice: 0,
                    amount: 1,
                    total: 0,
                    selected: true,
                    isAutoAdded: true, // Flag para identificar serviços adicionados automaticamente
                });
            }
        },
        currencyFormat(value) {
            return Utils.formatCurrency(value)
        },
        convertGroupNamePerSolution(solutionId) {
            const solutionFilter = this.allSolutions.filter(({ id }) => id == solutionId)
            if (solutionFilter.length) {
                const groupFilter = this.groupsData.filter(({ id }) => id == solutionFilter[0].groupId)
                return groupFilter.length > 0 ? groupFilter[0].name : "Não Existe"
            }
            return "Não Existe"
        },
        async saveProposal() {
            // Impedir salvamento se estiver em modo readonly
            if (this.readonly) {
                showErrorSnackBar("Esta proposta está faturada e não pode ser editada.");
                return;
            }
            
            if (this.$refs.typeProposalData && !this.$refs.typeProposalData.validate()) throw new Error("Preencha todos os campos!")
            
            const proposal = {
                typeProposal: this.typeProposal,
                listSolutions: this.listSolutions,
                listServices: this.listServices,
                listProducts: this.listProducts,
                createdAt: new Date(),
                revision: {}, // Sem revisão para propostas sem waterscan
                columnVisibility: this.columnVisibility || {
                    solution: true,
                    group: true,
                    quantity: true,
                    unitPrice: false,
                    total: false,
                    totalInvestment: true
                },
                // Status de aceite e faturamento
                status: 'pending', // 'pending', 'accepted', 'billed'
                acceptedAt: null,
                billedAt: null,
                billingOrderId: null,
                // Tag de origem para facilitar busca e filtragem
                origin: 'projects_kits'
            }

            // Adicionar id_diagnostic se existir (proposta com waterscan)
            if (this.diagnostic && this.diagnostic.id_doc) {
                proposal.id_diagnostic = this.diagnostic.id_doc;
            }

            // Adicionar id_lead e id_franchisee (obrigatórios para propostas sem waterscan)
            const leadId = this.idLead || (this.param && this.param.id_lead) || null;
            const franchiseeId = this.currentUserFranchiseeId;

            if (!leadId || !franchiseeId) {
                showErrorSnackBar("Lead ou Franqueado não identificado. Não é possível criar a proposta.");
                return;
            }

            proposal.id_lead = leadId;
            proposal.id_franchisee = franchiseeId;

            // Determinar se é edição: usa editProposalId (interno) ou proposalId (prop)
            const isEditMode = this.editProposalId || this.proposalId;
            const proposalDocId = this.editProposalId || this.proposalId;

            if(isEditMode){
                // Para edição, usar editProposal se não tiver id_diagnostic, senão usar editWaterScanProposal
                if (proposal.id_diagnostic) {
                    await DiagnosticProposalService.editWaterScanProposal(proposalDocId, {...proposal, id_doc: proposalDocId});
                } else {
                    await DiagnosticProposalService.editProposal(proposalDocId, {...proposal, id_doc: proposalDocId});
                }
                showSuccessSnackBar("Proposta atualizada com sucesso!");
            } else {
                // Para criação, usar createProposal se não tiver id_diagnostic, senão usar createDiagnostic
                if (proposal.id_diagnostic) {
                    await DiagnosticProposalService.createDiagnostic(proposal);
                } else {
                    await DiagnosticProposalService.createProposal(proposal);
                }
                showSuccessSnackBar("Proposta criada com sucesso!");
            }
        },
        async loadProposalById(proposalId) {
            try {
                const proposal = await DiagnosticProposalService.getProposalById(proposalId);
                if (proposal) {
                    // Adicionar id_doc ao objeto se não existir
                    if (!proposal.id_doc) {
                        proposal.id_doc = proposalId;
                    }
                    this.selectedProposal(proposal);
                }
            } catch (error) {
                console.error('Erro ao carregar proposta:', error);
                showErrorSnackBar('Erro ao carregar proposta para edição');
            }
        },
        async getProposalList(idDiagnostic) {
            // Buscar lista de propostas apenas para referência (não bloqueia tipos duplicados)
            
            if(idDiagnostic){
                // Buscar propostas vinculadas ao diagnóstico (waterscan)
                this.proposalList = await DiagnosticProposalService.getWaterScanProposalByDiagnosticId(idDiagnostic)
            } else {
                // Buscar propostas por id_lead e id_franchisee (sem waterscan)
                const leadId = this.idLead || (this.param && this.param.id_lead) || null;
                const franchiseeId = this.currentUserFranchiseeId;

                if (leadId && franchiseeId) {
                    this.proposalList = await DiagnosticProposalService.getProposalsByFranchiseeIdAndLeadId(
                        franchiseeId,
                        leadId
                    );
                } else {
                    this.proposalList = [];
                }
            }

            // Não aplicar filtragem por tipos já existentes - permitir múltiplas propostas do mesmo tipo
            // Apenas aplicar filtros da prospecção (desiredProposal)
            this.applyProposalTypeAvailability();
        },
        getColumnVisibility() {
            return this.columnVisibility;
        },
        setColumnVisibility(visibility) {
            this.columnVisibility = {
                ...this.columnVisibility,
                ...visibility
            };
        },
        getColumnVisibilityWithDefaults(proposal) {
            if (!proposal || !proposal.columnVisibility) {
            return {
                solution: true,
                group: true,
                quantity: true,
                unitPrice: false,
                total: false,
                totalInvestment: true
            }
            }
            return {
                solution: proposal.columnVisibility.solution ?? true,
                group: proposal.columnVisibility.group ?? true,
                quantity: proposal.columnVisibility.quantity ?? true,
                unitPrice: false,
                total: false,
                totalInvestment: proposal.columnVisibility.totalInvestment !== undefined ? proposal.columnVisibility.totalInvestment : true
            }
        },
        async updateExpireDate(){
            try {
                let expired = new Date();
                expired.setDate(expired.getDate() + this.daysToAdd);
                await DiagnosticProposalService.editWaterScanProposal(this.editProposalId, { expiredAt: expired });
                showSuccessSnackBar("Data atualizada com sucesso")
            } catch (error) {
                console.error('Error updating expire dates:', error);
                showErrorSnackBar("Erro ao atualizar datas de expiração");
            }
        },
        updateProviderPercentage() {
            if (this.typeProposal.isFranchise) {
                let total = Number(this.typeProposal.client_percentage || 0) + Number(this.typeProposal.franchise_percentage || 0);
                this.typeProposal.provider_percentage = total > 100 ? 0 : 100 - total;
            } else {
                this.typeProposal.provider_percentage = 100 - Number(this.typeProposal.client_percentage || 0);
            }
        },
        clearForm() {
            // Limpar formulário para criar nova proposta
            this.editProposalId = null;
            const fixedType = this.fixedProposalType; // Preservar tipo fixo
            this.typeProposal = {
                defaultPrice: 600.99,
                number_water_start: null,
                number_water_target: null,
                number_water_360: 0,
                number_reservation: 0,
                reservation_plan: 199.90,
                managementPlan: null,
                paybackMin: 50,
                paybackMax: 30,
                water_start_plan: 199.90,
                water_target_plan: 374.90,
                water_360_plan: 99.90,
                water_start_plan_month_additional_spot: 139.90,
                water_target_plan_month_additional_spot: 259.90,
                water_360_plan_month_additional_spot: 449.90,
                water_start_plan_yearly: 149.90,
                water_target_plan_yearly: 299.90,
                water_360_plan_yearly: 499.90,
                water_start_plan_yearly_additional_spot: 99.90,
                water_target_plan_yearly_additional_spot: 149.90,
                water_360_plan_yearly_additional_spot: 249.90,
                isFranchise: false,
                obs: '',
            };
            // Restaurar tipo fixo se existir
            if (fixedType) {
                this.typeProposal.type = fixedType;
            }
            this.listSolutions = [];
            this.listServices = [];
            this.listProducts = [];
                this.columnVisibility = {
                    solution: true,
                    group: true,
                    quantity: true,
                    unitPrice: false,
                    total: false,
                    totalInvestment: true
                };
        },
    },
    async created() {
        this.groupsData = await SolutionsGroup.getSolutionsGroup()
        this.allSolutions = await SolutionsServices.GetSolutions()

        const proposalType = this.typeProposal.type;

        // Initially apply availability using current selection and any prospection constraints
        this.applyProposalTypeAvailability();
        
        // Adicionar serviços automáticos se o tipo for kit_sell
        if (proposalType === 'kit_sell') {
            await this.addKitSellServices();
        }
    },
        watch: {
        show: {
            immediate: true,
            handler: async function (newValue)  {
                if (newValue) {
                    // Se tem proposalId, está em modo de edição
                    if (this.proposalId) {
                        await this.loadProposalById(this.proposalId);
                    }
                    
                    // Se tem fixedProposalType, fixar o tipo da proposta
                    if (this.fixedProposalType && !this.proposalId && !this.editProposalId) {
                        this.typeProposal.type = this.fixedProposalType;
                    }
                    
                    if (this.param && this.param.id_doc) {
                        // Fluxo com waterscan (diagnóstico)
                        this.diagnostic = this.param
                        await this.getProposalList(this.param.id_doc)
                        this.projectSolutions = cloneDeep(this.param.solutionList || [])
                        this.getSolutions()
                    } else if (this.idLead || (this.param && this.param.id_lead)) {
                        // Fluxo sem waterscan (apenas proposta)
                        this.diagnostic = this.param || {}
                        await this.getProposalList(null) // Buscar por id_lead e id_franchisee
                        // Para propostas sem waterscan, não há solutionList do diagnóstico
                        this.projectSolutions = []
                        this.listSolutions = [] // Iniciar vazio, permitir adicionar manualmente
                    }
                    
                    // Se não tem proposalId e não está carregando proposta existente, limpar formulário
                    if (!this.proposalId && !this.editProposalId) {
                        this.clearForm();
                        // Reaplicar fixedProposalType após clearForm
                        if (this.fixedProposalType) {
                            this.typeProposal.type = this.fixedProposalType;
                        }
                    }
                    
                    // Adicionar serviços automáticos se o tipo for kit_sell
                    if (this.typeProposal.type === 'kit_sell' && this.allSolutions.length > 0) {
                        await this.addKitSellServices();
                    }
                }
            }
        },
        proposalId: {
            immediate: false,
            handler: async function (newValue) {
                if (newValue && this.show) {
                    await this.loadProposalById(newValue);
                }
            }
        },
        desiredProposal: {
            handler() {
                // Re-apply option availability whenever prospection selection changes
                this.applyProposalTypeAvailability();
            },
            deep: true
        },
        'item.amount': function (newVal) {
            if (newVal !== null) {
                this.item.total = this.item.unitPrice * newVal
            }
        },
        'item.unitPrice': function (newVal) {
            if (newVal !== null) {
                this.item.total = this.item.amount * newVal
            }
        },
        'typeProposal.franchise_percentage': function (newVal) {
            if (newVal !== null) {
                this.updateProviderPercentage();
            }
        },
        'typeProposal.client_percentage': function (newVal) {
            if (newVal !== null) {
                this.updateProviderPercentage();
            }
        },
        'typeProposal.isFranchise': function(newVal){ 
            this.updateProviderPercentage()
        },
        'typeProposal.type': {
            handler: async function(newVal) {
                // Quando o tipo de proposta mudar para kit_sell, adicionar serviços automaticamente
                if (newVal === 'kit_sell' && this.allSolutions.length > 0) {
                    await this.addKitSellServices();
                } else if (newVal !== 'kit_sell') {
                    // Remover serviços automáticos se mudar para outro tipo
                    this.listServices = this.listServices.filter(service => !service.isAutoAdded);
                }
            },
            immediate: false
        }
    },

};
